import React from 'react';
import OwlCarousel from 'react-owl-carousel3';
import './ProductSlide.scss';

const ProductSlide = () => {
  return (
    <div id="first" className="productSlide">
      <OwlCarousel {...options}>
        <img
          className="productImage"
          src="/images/IntroImage3.jpg"
          alt="mainBanner1"
        />
        <img
          className="productImage"
          src="/images/IMG_2180-Edit.gif"
          alt="mainBanner2"
        />
        <img
          className="productImage"
          src="/images/IntroImage1.png"
          alt="mainBanner3"
        />
      </OwlCarousel>
    </div>
  );
};

export default ProductSlide;

// let settings = {
//   dots: false,
//   infinite: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   speed: 2000,
//   autoplaySpeed: 5000,
//   cssEase: 'linear',
// };

const options = {
  loop: true,
  nav: true,
  smartSpeed: 1000,
  autoplayTimeout: 5000,
  dots: false,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  autoplay: true,
  items: 1,
  navText: [
    "<i class='bx bx-chevron-left'></i>",
    "<i class='bx bx-chevron-right'></i>",
  ],
};
